
import React, { useEffect, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";

const Interview = () => {


  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);


  

  const headingStyle = {
    fontSize: "42px",
    fontWeight: "bold",
    marginBottom: "2px",
    color: "#fffff",
  };

  const subTextStyle = {
    fontSize: "0.85rem",
    color: "#ffffff",
    marginBottom: "30px",
    maxWidth: "800px",

  };

  const goalListStyle = {
    fontSize: "0.85rem",
    lineHeight: "1.6",
    marginLeft: "-20px",
    listStyleType: "disc",
    color: "#ffffff",
  };

  const cardStyle = {
    backgroundColor: "rgb(44, 48, 69)",
    borderRadius: "12px",
    padding: "16px",
    margin: "10px 0",
    textAlign: "left",
    position: "relative",
  };

  const avatarStyle = {
    width: "36px",
    height: "36px",
    marginBottom: "10px",
    borderRadius: "50%",
  };

  const nameStyle = {
    fontWeight: "bold",
    marginBottom: "5px",
    fontSize: "0.85rem",
    color: "#ffffff",
  };

  const questionStyle = {
    fontSize: "0.75rem",
    color: "#ccc",
    marginLeft:'-0.5rem',
    listStyleType: "disc",
  };
  const userTypeStyle = {
    fontSize: "0.7rem",
    backgroundColor: "#393E53",
    color: "#ffffff",
    position: "absolute",
    top: "10px",
    right: "10px",
    padding: "3px 11px",
    borderRadius: "40px",
  }

  // Sample SVGs (replace these with your actual SVG code)
  const avatars = {
    alex: (
      <svg style={avatarStyle} viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="32" fill="#f0c419" />
        <text x="32" y="40" fontSize="18" textAnchor="middle" fill="#000">AT</text>
      </svg>
    ),
    lila: (
      <svg style={avatarStyle} viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="32" fill="#4ecdc4" />
        <text x="32" y="40" fontSize="18" textAnchor="middle" fill="#000">LK</text>
      </svg>
    ),
    mara: (
      <svg style={avatarStyle} viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="32" fill="#ff6b6b" />
        <text x="32" y="40" fontSize="18" textAnchor="middle" fill="#000">MS</text>
      </svg>
    ),
    noah: (
      <svg style={avatarStyle} viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="32" fill="#48dbfb" />
        <text x="32" y="40" fontSize="18" textAnchor="middle" fill="#000">NW</text>
      </svg>
    ),
    declan: (
      <svg style={avatarStyle} viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="32" fill="#a29bfe" />
        <text x="32" y="40" fontSize="18" textAnchor="middle" fill="#000">GU</text>
      </svg>
    ),
    liam: (
      <svg style={avatarStyle} viewBox="0 0 64 64">
        <circle cx="32" cy="32" r="32" fill="#ffeaa7" />
        <text x="32" y="40" fontSize="18" textAnchor="middle" fill="#000">AJ</text>
      </svg>
    ),
  };

  const people = [
    {
      name: "Alex Trost",
      userType:"Founder",
      questions: [
      "What’s your biggest challenge when starting a new project?",
      "How do you currently find and hire talent?",
    ],
      avatar: avatars.alex,
    },
    {
      name: "Lila Kensington",
      userType:"Founder",
      questions: [
      "What would make you trust a creator or project manager faster?",
      "What tools do you wish were integrated into your current workflow?",

    ],
      avatar: avatars.lila,
    },
    {
      name: "Mara Sinclair",
      userType:"Project Manager",
      questions: [
      "How do you typically assign and track tasks?",
      "What makes project communication smooth for you?",
    ],
      avatar: avatars.mara,
    },
    {
      name: "Noah Wilson",
      userType:"Project Manager",
       questions: [
      "How do you handle file sharing and organization?",
      "What features would help you manage remote teams better?",

    ],
      avatar: avatars.noah,
    },
    {
      name: "Gabriel Uche",
      userType:"Freelancer",
     questions: [
      "How do you prefer to get paid for freelance work?",
      "What makes a project offer feel trustworthy or exciting?",

    ],
      avatar: avatars.declan,
    },
    {
      name: "Ayomide Johnson",
      userType:"Freelancer",
      questions: [
      "How do you decide which projects to apply for?",
      "What motivates you to keep improving your skills on a platform?",
    ],
      avatar: avatars.liam,
    },
  ];

  return (
   <Container
      fluid
      className="container-section"
      style={{
        backgroundColor: "#272A38",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: isSmallScreen ? "auto" : "100vh",
        paddingBottom: isSmallScreen ? "5rem" : "auto",
        paddingTop: isSmallScreen ? "5rem" : "auto",
      }}
    >
      <Row style={{justifyContent: "end",}}>
        <Col md={4} style={{color:"#ffffff"}}>
          <div style={headingStyle}>User interviews</div>
          <div style={subTextStyle}>
            To understand the target audience, I conducted semi-structured interviews 
            with founders, project managers, and creators, gaining diverse insights into 
            their collaboration, hiring, and project execution challenges.
          </div>
        </Col>
        <Col md={5} style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  }}>
          <div style={{ fontWeight: "bold", fontSize: "20px", color:"#ffffff"}}>
            Main goals of the interviews:
          </div>
          <ul style={goalListStyle}>
            <li>Understand pain points in current project collaboration and talent onboarding processes.</li>
            <li>Validate key feature needs</li>
            <li>
             Uncover motivation behind using Buidl — what would make them choose and stay on the platform.
            </li>
          </ul>

        </Col>
        <Col md={3} style={{
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
  }}>
         <div style={{ color: "#ffffff", marginBottom: "10px",fontSize: "0.85rem", }}>
            I conducted both phone and in-person interviews with users, guided by questions developed after reviewing platform requirements and brainstorming around user needs and challenges. <strong>The questions included:</strong>
          </div>
        </Col>
      </Row>

      <Row className="mt-1">
        {people.map((person, index) => (
          <Col key={index} md={4}>
            <div style={cardStyle}>
              <div style={userTypeStyle}>{person.userType}</div>
              {person.avatar}
              <div style={nameStyle}>{person.name}</div>
              <ul style={{ paddingLeft: "18px", margin: 0 }}>
          {person.questions.map((q, i) => (
            <li key={i} style={questionStyle}>{q}</li>
          ))}
        </ul>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default Interview;